import React from "react";


const Footer = () => {
    return (
        <div>
            <section className=" footer-main-sec">


                <div className="  container">
                    <div className="row">
                        <div className="col-md-3">
                            <p className="footer-link-head">About Us</p>
                            <p className="footer-link-para">The SVU Zoology Department Alumni Association unites a diverse and accomplished network of
                                graduates who have excelled in academia, research, and various industries worldwide.</p>

                            <p className="footer-link-head">Follow Us</p>
                            <div className=" d-flex  footer-social-section ">
                          
                            <a href="" target="_blank" rel="noopener noreferrer" className="facebook"> 
                            <i class="fa fa-facebook  " aria-hidden="true" ></i>
                            </a>

                            <a href="" target="_blank" rel="noopener noreferrer" className="facebook"> 
                           <i class="fa fa-twitter" aria-hidden="true"></i>
                            </a>

                            <a href="" target="_blank" rel="noopener noreferrer" className="facebook"> 
                         
                            <i class="fa fa-linkedin" aria-hidden="true"></i>
                            </a>

                   </div>
                        </div>

                        <div className="col-md-3">
                            <p className="footer-link-head">Alumni Association Links</p>
                            <ul className="list-unstyled footer-links">
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   about Alumni Association</li>
                                <li> <i class="fa fa-dot-circle-o" aria-hidden="true"></i>  Alumni Commitee</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Alumni Registration</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Elite Alumni</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Membership</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Yearwise Group Photos</li>
                            </ul>
                        </div>

                        <div className="col-md-3">
                            <p className="footer-link-head">Department Links</p>
                            <ul className="list-unstyled footer-links">
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   About Department</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   IJCAP Journals</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   IJCAP Society</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Events</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Circulars</li>
                                <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i>   Alumni Course wise</li>
                            </ul>
                        </div>

                        <div className="col-md-3">
                            <p className="footer-link-head">  Get In Touch</p>
                            <div className="d-flex  mt-0 ">

                                <span className="footer-icons  footer-call-icon"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <div>
                                    <p className="footer-icon-head">+91 9876543210</p>
                                </div>
                            </div>
                            <div className="d-flex  mt-0 ">

                                <span className="footer-icons footer-mail-icon"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                                <div>
                                    <p className="footer-icon-head">svuzoologyalumni@gmail.com</p>
                                </div>
                            </div>
                            <div className="d-flex  mt-0 ">

                                <span className="footer-icons  footer-map-icon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div>
                                    <p className="footer-icon-head">SVU Natural Sciences Block, SVU, Tirupati</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>








            </section>
            <div className=" text-center  copy-right-section">
        <p className="copy-right-section-para">© 2024. All rights reserved.</p>
      </div>
        </div>
    )
}

export default Footer;